import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import FadeInSection from "./FadeInSection";

const isHorizontal = window.innerWidth < 600;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  if (isHorizontal) {
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  } else {
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

function a11yProps(index) {
  if (isHorizontal) {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`
    };
  } else {
    return {
      id: `vertical-tab-${index}`
    };
  }
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: "theme.palette.background.paper",
    display: "flex",
    height: 300
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`
  }
}));

const JobList = () => {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const experienceItems = {
    Python: {
      jobTitle: "Programming for everybody (Getting started with Python)@",
      duration: "Nov 21, 2020",
      img : <img src={require("../components/assets/python.png")} alt="python" />,
      desc: [
        "Python is a programming language that lets you work quickly and integrate systems more effectively.",
        "I have been learning Python for about a year now and have been using it to build a few projects.",
        "An online non-credit course authorized by university of Michiga and offered through Coursera.",
    
      ],
      certificate : ["Verify at  " , <a href="https://www.coursera.org/account/accomplishments/verify/AQ396EV6K4VB">Certificate</a>]
    },
    Web_Desingn: {
      jobTitle: "HTML, CSS, and JavaScript for Web Developers@",
      duration: "Nov 11, 2020",
      img : <img src={require("../components/assets/john.png")} alt="web design" />,
      desc: [
        "This course is designed to help you get started with HTML, CSS, and JavaScript.",
        "It covers all the basics of HTML, CSS, and JavaScript so you can create a dynamic website.",
        "An online non-credit course authorized by Jhons hopkins University and offered through Coursera.",
      ],
      certificate : ["Verify at  " , <a href="https://www.coursera.org/account/accomplishments/certificate/ZQJXJX5QJXJX">Certificate</a>]
    },
    WorkShope_AI: {
      jobTitle: "WorkShope AI event of Tarang'19@",
      duration: "Nov 2,3 , 2019",
      img : <img src={require("../components/assets/AINIT.png")} alt="work shope AI" />,
      desc: [
        "WorkShope AI is an event organized by WorkShope, a non-profit organization that aims to provide a platform for students to learn and share their knowledge.",
        "This workshop provide School of Management Studies of National Institute of Technology, Calicut.",
      ]
    },
    Ethical_hacking: {
      jobTitle: "Ethical Hacking of Ragam'20@",
      duration: "jan 10,11,12 2020",
      img : <img src={require("../components/assets/HNIT.png")} alt="Ethical Hacking of Ragam" />,
      desc: [
          "Ethical Hacking workshop provide national institute of Technology calicut in Ragam'20'.",
      ]
    },
    "Robogreek'19": {
      jobTitle: "MES KC IEDC Robogreek'19@",
      duration: "Dec 10 and 11, 2019",
      img : <img src={require("../components/assets/robo.png")} alt="Robogreek" />,
      desc: [
        "MES KC IEDC Robogreek'19 is an event organized by MES, a non-profit organization that aims to provide a platform for students to learn and share their knowledge.",
        "This workshop use Arduino UNO Genuino UNO , The UNO is the best board to get started with electronics and coding. If this is your first experience tinkering with the platform, the UNO is the most robust board you can start playing with. The UNO is the most used and documented board of the whole Arduino & Genuino famil.",
        "This workshop provide IEDC MES kalladi College ",
      ]
      
    },
    "Command Line in Linux" : {
      jobTitle: "Command Line in Linux@",
      duration: "Mar 28, 2022",
      img : <img src={require("../components/assets/linux.png")} alt="Command Line in Linux" />,
      desc: [
        "Command Line in Linux is an interactive shell that allows you to execute commands on a Linux system.",
        "This workshop provide Couresara.org",
      ],
      certificate : ["Verify at  " , <a href="https://www.coursera.org/account/accomplishments/verify/QAPDDF7RRFJJ">Certificate</a>]
    },
    Hedge: {
      jobTitle: "Geteway to financial freedom@",
      duration: "Dec 6, 2019",
      img : <img src={require("../components/assets/hedge.png")} alt="Hedge" />,
      desc: [
        "Geteway to financial freedom is an event organized by Geteway to financial freedom, a non-profit organization that aims to provide a platform for students to learn and share their knowledge.",
        "foundation programme in capital markets. Conducted by hedge school of applied Economics, Kochin",
        
      ]
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <Tabs
        orientation={!isHorizontal ? "vertical" : null}
        variant={isHorizontal ? "fullWidth" : "scrollable"}
        value={value}
        onChange={handleChange}
        className={classes.tabs}
      >
        {Object.keys(experienceItems).map((key, i) => (
          <Tab label={isHorizontal ? `0${i}.` : key} {...a11yProps(i)} />
        ))}
      </Tabs>
      {Object.keys(experienceItems).map((key, i) => (
        <TabPanel value={value} index={i}>
          <span className="joblist-job-title">
            {experienceItems[key]["jobTitle"] + " "}
          </span>
          <span className="joblist-job-company">{key}</span>
          <div className="joblist-duration">
            {experienceItems[key]["duration"]}
          </div>
          <div className="joblist-img">
            <FadeInSection delay={`${i + 1}00ms`}>
            {experienceItems[key]["img"]}
            </FadeInSection>
          </div>
          <ul className="job-description">
            {experienceItems[key]["desc"].map(function (descItem, i) {
              return (
                <FadeInSection delay={`${i + 1}00ms`}>
                  <li key={i}>{descItem}</li>
                </FadeInSection>
              );
            })}
          </ul>
          <div className="joblist-certificate">
            
            <FadeInSection delay={`${i + 1}00ms`}>
              
            {/* if the certificate no don't show job list certficate*/
            experienceItems[key]["certificate"] ? experienceItems[key]["certificate"] : null}
            </FadeInSection>
          </div>

        </TabPanel>
      ))}
    </div>
  );
};

export default JobList;
